import React from 'react';

const OrderDetails = (props) => {
    const {
        order = null,
    } = props;

    return (
        <div className={"m-0 border rounded bg-eh-off-white border-eh-mid-grey p-3"}>
            <div className={"row m-0 p-0"}>
                <div className="col-12 col-md-6 col-lg-4 m-0 p-0 pr-md-2">
                    <p className="mb-0 text-eh-off-white"><strong>Date Created</strong></p>
                    <p className="text-eh-off-white">{!!order && !!order.date_created ? order.date_created : "-"}</p>
                </div>
                <div className="col-12 col-md-6 col-lg-4 m-0 p-0 pl-md-2 px-lg-2">
                    <p className="mb-0 text-eh-off-white"><strong>Price</strong></p>
                    <p className="text-eh-off-white">{!!order && !!order.price ? order.price : "-"}</p>
                </div>
                <div className="col-12 col-md-6 col-lg-4 m-0 p-0 pr-md-2 pr-lg-0 pl-md-2">
                    <p className="mb-0 text-eh-off-white"><strong>User Assigned</strong></p>
                    <p className="text-eh-off-white">{!!order && !!order.user_display ? order.user_display : "-"}</p>
                </div>
            </div>
            <div className={"row m-0 p-0"}>
                <div className="col-12 col-md-6 col-lg-4 m-0 p-0 pr-md-2">
                    <p className="mb-0 text-eh-off-white"><strong>Due Date</strong></p>
                    <p className="text-eh-off-white">{!!order && !!order.production_due_at_display ? order.production_due_at_display : "-"}</p>
                </div>
                <div className="col-12 col-md-6 col-lg-4 m-0 p-0 pl-md-2 px-lg-2">
                    <p className="mb-0 text-eh-off-white"><strong>Start Date</strong></p>
                    <p className="text-eh-off-white">{!!order && !!order.production_start_at_display ? order.production_start_at_display : "-"}</p>
                </div>
                <div className="col-12 col-md-6 col-lg-4 m-0 p-0 pl-md-2 px-lg-2">
                    <p className="mb-0 text-eh-off-white"><strong>Finish Date</strong></p>
                    <p className="text-eh-off-white">{!!order && !!order.production_finish_date_display ? order.production_finish_date_display : "-"}</p>
                </div>
            </div>
            <div className={"row m-0 p-0"}>
                <div className="col-12 col-md-6 col-lg-4 m-0 p-0 pr-md-2">
                    <p className="mb-0 text-eh-off-white"><strong>Order Priority</strong></p>
                    <p className="text-eh-off-white">{!!order && !!order.priority_display ? order.priority_display : "-"}</p>
                </div>
                <div className="col-12 col-md-6 col-lg-4 m-0 p-0 pl-md-2 px-lg-2">
                    <p className="mb-0 text-eh-off-white"><strong>Difficulty</strong></p>
                    <p className="text-eh-off-white">{!!order && !!order.difficulty ? order.difficulty : "-"}</p>
                </div>
                <div className="col-12 col-md-6 col-lg-4 m-0 p-0 pl-md-2 px-lg-2">
                    <p className="mb-0 text-eh-off-white"><strong>Type</strong></p>
                    <p className="text-eh-off-white">{!!order && !!order.order_type_display ? order.order_type_display : "-"}</p>
                </div>
            </div>
            <div className={"row m-0 p-0"}>
                <div className="col-12 m-0 p-0 pr-md-2">
                    <div className="col-12 m-0 p-0">
                        <p className="mb-0 text-eh-off-white"><strong>Notes</strong></p>
                        <p className="text-eh-off-white">{!!order && !!order.notes ? order.notes : "-"}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OrderDetails;
